import { useParams, useLocation, Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import MainLayout from "../../../../Layout/MainLayout";
import PageContainer from "../../../../components/layout/PageContainer";
import ManualVoucherForm from "../CreateVoucher/sections/ManualVoucher/ManualVoucherForm";

const EditVoucherPage = () => {
  const { id: voucherId } = useParams();
  const location = useLocation();
  const customTheme = location.state?.customTheme;
  const initialData = location.state?.initialData;
  const isReviewMode = Boolean(location.state?.isReviewMode || voucherId === 'review' || location.state?.fromAiExtraction);

  const isValidId = Boolean(voucherId && voucherId !== 'undefined' && voucherId !== 'null' && voucherId.trim() !== '');

  if (!isValidId && !isReviewMode) {
    return (
      <MainLayout activeTab="voucher">
        <div className="bg-slate-50 min-h-screen">
          <PageContainer>
            <div className="min-h-[60vh] flex flex-col items-center justify-center text-center p-6">
              <div className="w-16 h-16 bg-red-50 text-red-500 rounded-2xl flex items-center justify-center mb-4">
                <AlertCircle size={32} />
              </div>
              <h2 className="text-xl font-bold text-slate-800 mb-2">Unable to open voucher</h2>
              <p className="text-sm text-slate-500 max-w-md mb-6">
                Unable to open voucher. Please return to the voucher list and try again.
              </p>
              <Link
                to="/voucher"
                className="px-5 py-2.5 bg-[#067978] text-white rounded-xl font-semibold text-sm hover:bg-[#056362] transition-colors shadow-sm"
              >
                Return to Vouchers
              </Link>
            </div>
          </PageContainer>
        </div>
      </MainLayout>
    );
  }

  const isActualEdit = isValidId && voucherId !== 'review';

  return (
    <MainLayout activeTab="voucher">
      <div className="bg-slate-50 min-h-screen">
        <PageContainer>
          <ManualVoucherForm
            isEditMode={isActualEdit}
            isReviewMode={isReviewMode}
            voucherId={isActualEdit ? voucherId : null}
            initialData={initialData}
            customTheme={customTheme}
          />
        </PageContainer>
      </div>
    </MainLayout>
  );
};

export default EditVoucherPage;

